import r from "./isArray.js";
import { slice as f } from "./_setup.js";
import o from "./isString.js";
import t from "./_isArrayLike.js";
import m from "./map.js";
import i from "./identity.js";
import s from "./values.js";
var u = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function a(a) {
  return a ? r(a) ? f.call(a) : o(a) ? a.match(u) : t(a) ? m(a, i) : s(a) : [];
}
export { a as default };